import axios from "axios";
import axiosInstance from "../utils/axiosInstance";

const login = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/auth/login/`,
      data
    );
    return res;
  } catch (e) {
    console.log(e);
    return e;
  }
};

// Called after login returns mfa_required: true
// mfa_token is the short-lived token from the login response
const mfaVerifyLogin = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/auth/mfa/verify-login/`,
      data
    );
    return res;
  } catch (e) {
    return e;
  }
};

// Get the current user's MFA status
const mfaStatus = async () => {
  return axiosInstance.get("/auth/mfa/status/");
};

// Generate a new TOTP secret + QR code image for setup
const mfaSetup = async () => {
  return axiosInstance.post("/auth/mfa/setup/");
};

// Confirm setup by verifying the first TOTP code from Google Authenticator
const mfaConfirmSetup = async (code) => {
  return axiosInstance.post("/auth/mfa/confirm-setup/", { code });
};

// Disable MFA — requires the user's current TOTP code as confirmation
const mfaDisable = async (code) => {
  return axiosInstance.post("/auth/mfa/disable/", { code });
};

export {
  login,
  mfaVerifyLogin,
  mfaStatus,
  mfaSetup,
  mfaConfirmSetup,
  mfaDisable,
};